import React, { useEffect, useState } from "react";
import Button from "components/CustomButtons/Button.js";
import { get } from "../../utility";

export default function VerifyEmail() {
  const [status, setStatus] = useState("Verifying email...");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setStatus("Verification link is missing a token.");
      return;
    }

    get(`/profile/email/verify?token=${encodeURIComponent(token)}`)
      .then((res) =>
        res.ok ? res.json() : Promise.resolve({ isSuccessful: false })
      )
      .then((data) =>
        setStatus(
          data.isSuccessful
            ? "Email verified. You can return to the portal."
            : "Verification link is invalid or expired."
        )
      )
      .catch(() => setStatus("Verification failed. Please try again later."));
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f7fb",
        padding: 24,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 460,
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: 8,
          padding: 28,
          textAlign: "center",
        }}
      >
        <h1 style={{ margin: "0 0 12px", fontSize: 24 }}>Email Verification</h1>
        <p style={{ color: "#64748b", marginBottom: 22 }}>{status}</p>
        <Button href="/login" color="primary">
          Go to login
        </Button>
      </div>
    </div>
  );
}
